import {
  _ON_HOLD_TYPES,
  _SUPPLIER_ON_HOLD_TYPES,
  IOnHoldCodeDecodeOptions,
} from '../../../../features/settings-new/models/on-hold-code/on-hold-code.interface';


//#region FUNCTION decodeOnHoldCode

export function decodeOnHoldCode(onHoldCode: number, options?: IOnHoldCodeDecodeOptions): string[] {
  const {returnCodes = false, isSupplier = false} = options ?? {};

  if (!onHoldCode || onHoldCode < 0) {
    return [];
  }

  const binary = onHoldCode.toString(2);
  let types: string[] = [];
  const lookUp = isSupplier ? {..._SUPPLIER_ON_HOLD_TYPES} : {..._ON_HOLD_TYPES};

  for (let i = 0; i < binary.length; i++) {
    if (binary[binary.length - 1 - i] === '1') {
      const int = 2 ** i;

      if (lookUp.hasOwnProperty(int)) {
        if (!returnCodes) {
          types = types.concat(lookUp[int]);
        } else {
          types = types.concat('' + int);
        }
      }
    }
  }

  return types;
}

//#endregion

//#region FUNCTION encodeOnHoldCode
export function encodeOnHoldCode(types: string[], isSupplier: boolean = false): number {
  const lookUp = isSupplier ? _SUPPLIER_ON_HOLD_TYPES : _ON_HOLD_TYPES;
  const typeToInt: Record<string, number> = {};

  for (const key in lookUp) {
    const intKey = parseInt(key, 10);
    const value = lookUp[key];
    typeToInt[value] = intKey;
  }

  let code = 0;

  for (const type of types) {
    if (typeToInt[type]) {
      code += typeToInt[type];
    }
  }

  return code;
}

//#endregion

//#region FUNCTION getOnHoldCodeLabel
export function getOnHoldCodeLabel(code: number, isSupplier: boolean = false): string {
  const types = decodeOnHoldCode(code, {isSupplier});
  return types.length > 0 ? types.join(', ') : 'None';
}

//#endregion

//#region FUNCTION getAllOnHoldOptions
export function getAllOnHoldOptions(isSupplier: boolean = false): { code: number; label: string }[] {
  const lookUp = isSupplier ? {..._SUPPLIER_ON_HOLD_TYPES} : {..._ON_HOLD_TYPES};
  const options: { code: number; label: string }[] = [];

  for (const key in lookUp) {
    const code = parseInt(key, 10);
    const label = lookUp[code];
    if (label !== 'NA') {
      options.push({code, label});
    }
  }

  return options.sort((a: { code: number; label: string }, b: { code: number; label: string }) => a.code - b.code);
}

//#endregion


//#region PREVIOUS WAY TO BE REMOVED
export const onHoldDecode = (onHoldCode: number, codes = false, supplier?: boolean): string[] => {
  if (onHoldCode && onHoldCode >= 0) {
    const binary = onHoldCode.toString(2);
    let types: string[] = [];
    const lookUp = supplier ? _SUPPLIER_ON_HOLD_TYPES : _ON_HOLD_TYPES;

    for (let i = 0; i < binary.length; i++) {
      if (binary[binary.length - 1 - i] === '1') {
        const int = 2 ** i;
        if (lookUp.hasOwnProperty(int)) {
          if (!codes) {
            types = types.concat(lookUp[int]);
          } else {
            types = types.concat('' + int);
          }
        } else {
          return null;
        }
      }
    }
    return types;
  } else {
    return [];
  }
};
export const onHoldStockItemsEncode = (types: string[], supplier?: boolean): number | null => {
  const lookUp = supplier ? _SUPPLIER_ON_HOLD_TYPES : _ON_HOLD_TYPES;
  const typeToInt: Record<string, number> = {};

  for (const key in lookUp) {
    const intKey = parseInt(key, 10);
    const value = lookUp[key];

    if (Array.isArray(value)) {
      for (const type of value) {
        typeToInt[type] = intKey;
      }
    } else {
      typeToInt[value] = intKey;
    }
  }
  let code = 0;
  for (const type of types) {
    if (typeToInt.hasOwnProperty(type)) {
      code += typeToInt[type];
    } else {
      return null;
    }
  }
  return code;
};
export const onHoldEncode = (types: string[]): number => {
  let code = 0;

  if (typeof types === 'string') {
    types = [types];
  }

  for (const type of types) {
    for (const num of Object.keys(_ON_HOLD_TYPES)) {
      if (_ON_HOLD_TYPES[num] === type) {
        code = +code + +num;
        break;
      }
    }
  }
  return code > 0 ? code : undefined;
};
//#endregion